import { useEffect } from "react";

function useInterval(callback, delay) {
  // Set up the interval.
  useEffect(() => {
    // Don't schedule if no delay is specified.
    // Note: 0 is a valid value for delay.
    if (!delay && delay !== 0) {
      return;
    }

    const id = setTimeout(() => callback(), delay);
    return () => clearTimeout(id);
  }, [delay]);
}

export default useInterval;
